export default {
  async setVideoEffect(effect, virtualBgModel) {
    if (!this.virtualBackground) {
      this.virtualBackground = virtualBgModel;
    }
    this.videoEffect = effect;

    try {
      await this.virtualBackground
        .setEffect(effect)
        .setProvider('agora')
        .performSegmentation(this.videoDevice);

      let stream = await this.publishStreamToChannel();
      return { stream };
    } catch (error) {
      return { error };
    }
  }
}

